import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, useAuth } from "@/contexts/AuthContext";

// TEMPORARY — Only renders for info+taaft1@casahaya.com. Lets this one
// regression-test account switch its effective subscription_plan between
// the 12 tiers without touching Stripe. Backend hard-gates by email too.
const EXEMPT_EMAIL = "info+taaft1@casahaya.com";
const TIERS = [
  "Kickstart 1", "Kickstart 2", "Kickstart 3",
  "Starter", "Creator", "Business", "Agency",
  "Enterprise Basic", "Enterprise Plus", "Enterprise Advanced",
  "Enterprise Elite", "Enterprise Unlimited",
];

export default function TestTierSwitcher() {
  const { user, refresh } = useAuth();
  const ownWorkspace = !user?.active_workspace || user.active_workspace === user?.id;
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [current, setCurrent] = useState(user?.subscription_plan || "");

  useEffect(() => {
    setCurrent(user?.subscription_plan || "");
  }, [user?.subscription_plan]);

  if (!ownWorkspace || (user?.email || "").toLowerCase() !== EXEMPT_EMAIL) return null;

  const switchTo = async (plan) => {
    if (plan === current || busy) return;
    setBusy(true);
    try {
      await axios.post(`${API}/dev/test-tier`, { plan_key: plan }, { withCredentials: true });
      await refresh();
      setCurrent(plan);
      toast.success(`Switched to ${plan}`);
      setOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Switch failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="test-tier-switcher"
      className="fixed bottom-4 right-4 z-[9999]"
    >
      {open && (
        <div
          className="mb-2 w-72 rounded-xl border border-red-300 bg-white shadow-2xl p-2"
          data-testid="test-tier-switcher-menu"
        >
          <div className="px-2 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-red-600 border-b border-red-100 mb-1">
            TEST override · not real billing
          </div>
          <div className="max-h-[320px] overflow-y-auto">
            {TIERS.map((t) => (
              <button
                key={t}
                data-testid={`test-tier-option-${t.toLowerCase().replace(/\s+/g, "-")}`}
                disabled={busy}
                onClick={() => switchTo(t)}
                className={`w-full text-left px-3 py-2 text-[13px] rounded-md transition-colors
                  ${t === current ? "bg-red-50 text-red-700 font-semibold" : "hover:bg-gray-100 text-gray-800"}
                  disabled:opacity-50`}
              >
                {t}{t === current ? "  ←  active" : ""}
              </button>
            ))}
          </div>
        </div>
      )}
      <button
        data-testid="test-tier-switcher-toggle"
        onClick={() => setOpen((o) => !o)}
        className="rounded-full bg-red-600 text-white text-[12px] font-semibold px-4 py-2 shadow-lg hover:bg-red-700 transition-colors flex items-center gap-2"
      >
        <span className="inline-block w-2 h-2 rounded-full bg-white animate-pulse" />
        TEST TIER: {current || "—"}
      </button>
    </div>
  );
}
